<template>
  <v-app id="inspire">
      <v-content>
        <v-container fluid fill-height>
          <v-layout align-center justify-center>
            <v-flex xs12 sm6 md4 lg3 xl3>
              <v-card class="elevation-12">
                <v-toolbar dark color="purple">
                  <v-toolbar-title>Login</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-tooltip bottom>
                    <v-icon large>code</v-icon>
                    <span>Source</span>
                  </v-tooltip>
                </v-toolbar>
                <v-card-text>
                  <v-form>
                    <v-layout>
                      <v-flex mx-4>
                        <v-text-field 
                          prepend-icon="person"
                          id="login"
                          label="Login" 
                          type="text" 
                          v-model="username" 
                          @blur="$v.username.$touch()"
                          :class="{invalid: $v.username.$error}"
                        ></v-text-field>
                        <!-- <p v-if="!$v.username.required">This field must not be empty</p> -->
                        <v-text-field 
                          id="password" 
                          prepend-icon="lock" 
                          label="Password"
                          type="password"
                          v-model="password"
                          @blur="$v.password.$touch()"
                          @keyup.enter.native="Authenticate"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout align-center justify-center column>
                      <v-flex 
                        v-if="test_alerts || bad_creds" 
                        class="red--text subheading text-center" 
                        align-center 
                        justify-center
                      >
                        <v-icon class="red--text">highlight_off</v-icon> Unable to log in with provided credentials
                      </v-flex>
                      <v-flex 
                        v-if="test_alerts || account_not_activated" 
                        class="red--text subheading text-center" 
                        align-center 
                        justify-center
                      >
                        <v-icon class="red--text">highlight_off</v-icon> This account is not activated yet. Please contact your administrator.
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn 
                    color="purple white--text"
                    :disabled="$v.username.$error || $v.password.$error || this.authStatus == 'loading'"
                    @click="Authenticate"
                  >Login</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </v-content>
    </v-app>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      username: null,
      password: null,
      bad_creds: false,
      account_not_activated: false,
      test_alerts: false,
    }
  },
  computed: {
    ...mapGetters([
      'authStatus',
      'notActivated'
      ]),
  },
  methods: {
    Authenticate() {
      if (this.username && this.password) {
        let username = this.username;
        let password = this.password;
        this.bad_creds = false
        this.account_not_activated = false

        this.$store
          .dispatch('login', {username:username, password:password})
          .then(() => {
            if (this.notActivated) {
              this.account_not_activated = true
            } else {
              this.$router.push({name:'home'})
            }            
          })
          .catch(err => 
            {
              console.log(err)
              if (err.response.status == 400){
                this.bad_creds = true
              }
            });
      } 
    }
  },
  validations: {
    username: {
      required,
    },
    password: {
      required,
    }
  }
}
</script>

<style>
.invalid {
  border: 1px solid red;
  background-color: #ffc9aa;
  border-radius: 20px;
}
</style>
